import { ifProp, theme } from 'styled-tools';

import SectionHeadline from '@/components/ui/elements/SectionHeadline';
import breakpoint from 'styled-components-breakpoint';
import styled from 'styled-components';

const Section = styled.section`
  padding: 4em 1rem;

  ${breakpoint('lg')`
    padding-right: 6rem;
    padding-left: 6rem;
  `}
  ${breakpoint('md', 'lg')`
    padding-right: 4rem;
    padding-left: 4rem;
  `}
  ${breakpoint('sm', 'md')`
    padding-right: 3rem;
    padding-left: 3rem;
  `}
  ${breakpoint('xs', 'sm')`
    padding-right: 1.5rem;
    padding-left: 1.5rem;
  `}
`;

const Article = styled.article<{ bgColor?: string }>`
  padding-bottom: 6rem;

  color: ${ifProp({ bgColor: 'blue' }, theme('colors.white'), theme('colors.blue'))};

  ${SectionHeadline} {
    text-align: center;
    margin-top: 0;
    margin-bottom: 2em;
  }
`;

export { Article, Section };
